import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    result: '-15 cm',
    quote: 'En 21 días me sentí más liviana: bajó la hinchazón de la tarde y dejé de llegar a la noche con antojos. Noté un cambio real en la cintura y lo pude sostener.',
    name: 'Carmen M.',
    age: '44 años',
    country: 'México'
  }, {
    result: '-12 cm',
    quote: 'Lo que me cambió fue la estructura: proteína en el desayuno, plato simple al mediodía y caminata corta post comida. En mi caso noté cambios en cintura y recuperé energía; ya no vivo a café y fuerza de voluntad.',
    name: 'Sofía R.',
    age: '39 años',
    country: 'Colombia'
  }, {
    result: '-14 cm',
    quote: 'Después de 3 embarazos y ya en plena perimenopausia, lo que necesitaba era un método claro. H.E.R. me ayudó a ordenar comidas, sueño y movimiento sin matarme entrenando. Me desinflamé y volví a notar cambios reales en la ropa.',
    name: 'Ana L.',
    age: '47 años',
    country: 'Argentina'
  }];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-284">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-285">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-286">
          <p className="text-secondary font-bold uppercase tracking-wider text-sm" data-id="element-287">
            Lo que cuentan mujeres que hicieron H.E.R.
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-288">
            Resultados <span className="text-gradient-gold" data-id="element-289">Reales</span>
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-290">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-card border border-border rounded-2xl p-6 md:p-8 relative hover:border-gold/30 transition-colors duration-300 mt-4 md:mt-0" data-id="element-291">
              <div className="space-y-6" data-id="element-292">
                {/* Stars */}
                <div className="flex gap-1" data-id="element-293">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-294" />)}
                </div>

                {/* Quote */}
                <p className="text-foreground/90 font-body font-medium italic text-base md:text-lg leading-relaxed" data-id="element-295">
                  "{t.quote}"
                </p>

                {/* Author Info */}
                <div className="pt-4 border-t border-border/50" data-id="element-296">
                  <p className="font-display font-bold text-lg text-gold-light" data-id="element-297">
                    {t.name}
                  </p>
                  <p className="text-sm text-foreground/60 font-body mt-1" data-id="element-298">
                    {t.age} • {t.country}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}